// extracted by mini-css-extract-plugin
export default {"heading":"Gallery_heading__egwnN","galleryDiv":"Gallery_galleryDiv__iU3cE","modal":"Gallery_modal__6-l3Z","modalContent":"Gallery_modalContent__mHE+C"};